import one from '../assets/svg/projects/purpple.png'
import two from '../assets/svg/projects/porter.png'
import three from '../assets/svg/projects/edutech.png'
import four from '../assets/svg/projects/four.svg'
import five from '../assets/svg/projects/five.svg'
import six from '../assets/svg/projects/six.svg'
import seven from '../assets/svg/projects/seven.svg'
import eight from '../assets/svg/projects/eight.svg'


export const projectsData = [
    {
        id: 1,
        projectName: 'Purpple Clone',
        projectDesc: 'Purpple.com is a e-commerce web site which sell cosmetics.',
        tags: [ 'CSS', 'HTML', 'JavaScript'],
        code: 'https://github.com/bhawaniCodes/Purplle',
        demo: 'https://frozen-castle-82316.herokuapp.com/',
        image: one
    },
    {
        id: 2,
        projectName: 'Porter Clone',
        projectDesc: 'Porter.in is a web site which provide all type of vehicle for logistic purpose.',
        tags: ['CSS', 'HTML', 'JavaScript', 'Express', 'MongoDB'],
        code: 'https://github.com/stockchandu/Project-Porter-v2',
        demo: 'https://project-porter.herokuapp.com/',
        image: two
    },
    {
        id: 3,
        projectName: 'Learn It',
        projectDesc: 'Learn it is a Education web site, you can learn any course on it.',
        tags: ['CSS', 'HTML', 'JavaSript', "Express", 'MongoDB', 'React'],
        code: 'https://github.com/abhishek-hero/Project_Edutech',
        demo: 'https://learnit-seven.vercel.app/',
        image: three
    },
    {
        id: 4,
        projectName: 'Android Patient Tracker',
        projectDesc: 'This project involves the development of an Android application for viewing and managing patient data.',
        tags: ['Flutter', 'Firebase'],
        code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
        demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
        image: four
    },
    {
        id: 5,
        projectName: 'E-Commerce App',
        projectDesc: 'A Simple E-commerce application',
        tags: ['React Native', 'Firebase'],
        code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
        demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
        image: five
    },
    {
        id: 6,
        projectName: 'Uber Lite',
        projectDesc: 'Uber clone',
        tags: ['Flutter'],
        code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
        demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
        image: six
    },
    {
        id: 7,
        projectName: 'Stock Market App',
        projectDesc: 'A simple stock market API app',
        tags: ['React', 'Redux', 'Bootstrap'],
        code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
        demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
        image: seven
    },
    {
        id: 8,
        projectName: 'Car Pooling System',
        projectDesc: 'The carpooling system merges multiple people in a car which leads to meet new people, reduces pollution',
        tags: ['Flutter', 'React'],
        code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
        demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
        image: eight
    },
]


// Do not remove any fields.
// Leave it blank instead as shown below

/* 
{
    id: 1,
    projectName: 'Car Pooling System',
    projectDesc: '',
    tags: ['Flutter', 'React'],
    code: '',
    demo: '',
    image: ''
}, 
*/